import { Component, OnChanges, Input, SimpleChange,EventEmitter, Output, } from '@angular/core';

@Component({
  selector: 'app-passwordstrength',
  templateUrl: './passwordstrength.component.html',
  styleUrls: ['./passwordstrength.component.css']
})
export class PasswordstrengthComponent implements OnChanges {
  @Input() passwordToCheck: string;  
  @Input() barLabel: string;
  @Output() frmcomplexscore = new EventEmitter<any>();
    bar0: string;
    bar1: string;  
    bar2: string;  
    bar3: string;  
    bar4: string;  
    _score =0;
    public formcomplexscore: any;
    private colors = ['#F00', '#F90', '#FF0', '#9F0', '#0F0']; 
  constructor() { }
  private static measureStrength(pass: string) {  
    let score = 0;    
          // award every unique letter until 5 repetitions  
    let letters = {};  
   
    // bonus points for mixing it up  
    let variations = {  
    digits: /\d/.test(pass),  
    lower: /[a-z]/.test(pass),     
    upper: /[A-Z]/.test(pass),  
    nonWords: /\W/.test(pass),  
    };  
    let variationCount = 0;  
    for (let check in variations) {     
    variationCount += (variations[check]) ? 1 : 0;  
    } 
    
    if(pass.length>=8 && variationCount==4) {
    for (let i = 0; i< pass.length; i++) {  
      letters[pass[i]] = (letters[pass[i]] || 0) + 1;  
      score += 8.0 / letters[pass[i]];  
      } 
    } 
   score += (variationCount - 1) * 10;  
   return Math.trunc(score);  
  }

  private getColor(score: number) {  
      let idx = 0;  
      if (score > 90) {  
        idx = 4;  
      } else if (score > 70) {  
        idx = 3;  
      } else if (score >= 40) {  
        idx = 2;  
      } else if (score >= 20) {  
        idx = 1;  
      }  
      this._score=score;   
      this.formcomplexscore = this._score;    
      this.frmcomplexscore.emit(this.formcomplexscore); 
      return {  
        idx: idx + 1,  
        col: this.colors[idx]  
      };  
      
    }

    private setBarColors(count, col) { 
      for (let _n = 0; _n < count; _n++) {  
          this['bar' + _n] = col;  
      } 
  }
  ngOnChanges(changes: {[propName: string]: SimpleChange}): void {
    var password = changes['passwordToCheck'].currentValue;  
      this.setBarColors(5, '#DDD');  
      if (password) {  
      let c = this.getColor(PasswordstrengthComponent
        .measureStrength(password));  
            this.setBarColors(c.idx, c.col);  
            }  
  }

}
